export const learnersTableText = {
  search: 'Search',
  name: 'Name',
  email: 'Email',
  groups: 'Groups',
  role: 'Role',
  selectAll: 'Select all',
  learnersCount: (count: number) =>
    `${count} ${count === 1 ? 'learner' : 'learners'}`,
  previousPage: 'Previous page',
  nextPage: 'Next page',
};
